export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden" style={{ 
      backgroundImage: 'url(https://public.readdy.ai/ai/img_res/680391f89d26dd0aeff2a6a1a6b596cb.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-teal-900/90 via-teal-800/70 to-transparent"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-shield-check-line text-teal-300 text-lg"></i>
            <span className="text-white text-sm font-medium">Trusted VPN Solution</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Secure Your Digital Privacy
          </h2>
          
          <p className="text-xl text-teal-50 mb-8 leading-relaxed">
            METALAGRO S.R.L. provides enterprise-grade VPN solutions that protect your online activities with military-grade encryption, ensuring complete privacy and security for all your internet connections.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <button onClick={scrollToContact} className="bg-white text-teal-900 px-8 py-4 rounded-full hover:bg-teal-50 transition-all font-semibold text-lg shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
              Get Started
            </button>
            <button onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })} className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white/10 transition-all font-semibold text-lg whitespace-nowrap cursor-pointer">
              Learn More
            </button>
          </div>
          
          <div className="mt-12 flex flex-wrap gap-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full">
                <i className="ri-lock-line text-white text-xl"></i>
              </div>
              <div>
                <div className="text-white font-semibold">256-bit Encryption</div>
                <div className="text-teal-100 text-sm">Military Grade</div>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full">
                <i className="ri-global-line text-white text-xl"></i>
              </div>
              <div>
                <div className="text-white font-semibold">Global Servers</div>
                <div className="text-teal-100 text-sm">Worldwide Coverage</div>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full">
                <i className="ri-speed-line text-white text-xl"></i>
              </div>
              <div>
                <div className="text-white font-semibold">High Speed</div>
                <div className="text-teal-100 text-sm">No Throttling</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
